import { inject, Injectable } from '@angular/core';
import { BoomerHttpClient } from '../../../shared/services/boomer-http-client';
import { Observable } from 'rxjs';

export type IntakeFormData = {
  agentDisplayId: string;
  firstName: string;
  lastName: string;
  email: string;
  birthDate: string;
  medicareFamiliarity?: string;
  currentInsuranceType?: string;
  preferredInsuranceStartDate?: string;
  currentCarrier?: string;
  enrolledInMedicare?: boolean;
  additionalInfo?: string;
  referringPerson?: string;
};

@Injectable({
  providedIn: 'root',
})
export class IntakeFormService {
  private http = inject(BoomerHttpClient);

  submitIntakeForm(data: IntakeFormData): Observable<null> {
    return this.http.post<null>('/intake/submit', data);
  }
}
